import { emAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/emAdapter';
import { corporateAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/corporateAdapter';
import { absAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/absAdapter';
import { ISubscriptionAdapter, IAdapterContext } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/types';

const adapters: ISubscriptionAdapter[] = [
  emAdapter,
  corporateAdapter,
  absAdapter,
];

export const selectAdapter = (context: IAdapterContext): ISubscriptionAdapter => {
  const adapter = adapters.find((adapter) => adapter.shouldUse(context));

  if (!adapter) {
    throw new Error('No subscription adapter found for current context');
  }

  return adapter;
};
